function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st40{fill:#F4ABBA;}\n\t.st41{fill:#FF6344;}\n\t.st42{fill:#EF7385;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st40",
  d: "M142.8,238.9h117.8l12.1,1.6c45.7,8.3,80.4,45.8,85.1,91.9c4.7,46.2-21.6,89.9-64.7,107.3V467 c0,3.6-2.9,6.5-6.5,6.5h-39.1c-3.6,0-6.5-2.9-6.5-6.5v-19.5h-91.2V467c0,3.6-2.9,6.5-6.5,6.5h-39.1c-3.6,0-6.5-2.9-6.5-6.5v-27.2 c-28.4-11.6-50.3-35-59.9-64.1H13c-3.6,0-6.5-2.9-6.5-6.5v-52.1c0-3.6,2.9-6.5,6.5-6.5h24.8c9.7-29.1,31.6-52.5,60-64.1v-39.6 c0-1.9,0.8-3.7,2.2-5c1.4-1.3,3.3-1.8,5.2-1.6C124.8,203.6,140,219.2,142.8,238.9z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M384.5,349.7c0-7.2-5.8-13-13-13h-6.8c-2.8-51-40.4-93.5-90.7-102.5l-2.3,12.8c42.8,7.8,75.3,42.9,79.7,86.2 c4.4,43.3-20.2,84.3-60.6,100.6c-2.5,1-4.1,3.4-4.1,6.1V467h-39.1v-19.5c0-3.6-2.9-6.5-6.5-6.5h-91.2c-3.6,0-6.5,2.9-6.5,6.5V467 h-39.1v-27.2c0-2.7-1.6-5-4.1-6C73.6,423,53,401,44.1,373.7c-0.9-2.7-3.4-4.5-6.2-4.5H13v-52.1h24.8c2.8,0,5.3-1.8,6.2-4.5 c9-27.3,29.6-49.3,56.2-60c2.5-1,4.1-3.4,4.1-6.1l-0.1-39.7c16.8,2.9,29.8,16.2,32.3,33c0.5,3.2,3.2,5.6,6.4,5.6h26.6v-13h-21.2 c-5-20.1-21.6-35.2-42-38.4c-3.7-0.6-7.5,0.4-10.3,2.9c-3,2.5-4.7,6.2-4.6,10.1v35.3c-26.8,12.1-47.7,34.3-58,61.8H13 c-7.2,0-13,5.8-13,13v52.1c0,7.2,5.8,13,13,13h20.2c10.4,27.5,31.2,49.7,58,61.8V467c0,7.2,5.8,13,13,13h39.1c7.2,0,13-5.8,13-13 v-13h78.2v13c0,7.2,5.8,13,13,13h39.1c7.2,0,13-5.8,13-13v-22.9c37.6-16.9,62.6-53.3,64.9-94.4h6.8v13c0,7.2,5.8,13,13,13h6.5v-13 h-6.5V349.7z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M97.7,297.5c7,1.7,11.2,8.8,9.5,15.8l12.7,3.1c3.5-14-5.1-28.1-19-31.6c-14-3.5-28.1,5.1-31.6,19l12.7,3.1 C83.7,300.1,90.8,295.8,97.7,297.5z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M182.5,265h78.2v13h-78.2V265z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "st41",
  d: "M84.7,167.2h13v-6.5c7.2,0,13-5.8,13-13v-6.5c0-7.2-5.8-13-13-13h-13v-6.5h26.1v-13h-13V102h-13v6.5 c-7.2,0-13,5.8-13,13v6.5c0,7.2,5.8,13,13,13h13v6.5H71.7v13h13V167.2z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "st41",
  d: "M215,154.2h13v-6.5c7.2,0,13-5.8,13-13v-6.5c0-7.2-5.8-13-13-13h-13v-6.5h26.1v-13h-13V89h-13v6.5 c-7.2,0-13,5.8-13,13v6.5c0,7.2,5.8,13,13,13h13v6.5H202v13h13V154.2z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "st41",
  d: "M215,245.4h13v13h-13V245.4z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  className: "st41",
  d: "M215,219.3h13v13h-13V219.3z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  className: "st41",
  d: "M215,193.3h13v13h-13V193.3z"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  className: "st41",
  d: "M215,167.2h13v13h-13V167.2z"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  className: "st41",
  d: "M273.8,224.3l-9.1-9.4c-3.3,3.2-6.4,6.7-9.3,10.4l10.3,8C268.2,230.2,270.9,227.1,273.8,224.3z"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  className: "st41",
  d: "M293.4,210.2l-6-11.5c-4.1,2.2-8.1,4.6-11.9,7.3l7.6,10.6C286.3,214.2,289.8,212.1,293.4,210.2z"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  className: "st41",
  d: "M316.1,202.1l-2.7-12.7c-4.5,1-9,2.2-13.4,3.8l4.4,12.3C308.3,204,312.2,202.9,316.1,202.1z"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  className: "st41",
  d: "M258.9,243.4l-11.3-6.5c-2.5,4.1-4.5,8.5-6.2,13l12.4,4.1C255.2,250.4,256.9,246.8,258.9,243.4z"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  className: "st41",
  d: "M189,251.9h13c-0.1-2.5-0.3-4.9-0.7-7.4l-12.9,1.8C188.7,248.2,188.9,250.1,189,251.9z"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  className: "st41",
  d: "M185.7,234.2l12.5-3.8c-1.4-4.6-3.1-9.1-5.1-13.4l-11.9,5.4C183,226.2,184.5,230.2,185.7,234.2z"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  className: "st41",
  d: "M175.3,211.3l11-6.9c-2.5-4-5.3-7.9-8.3-11.6l-10.1,8.2C170.6,204.2,173.1,207.7,175.3,211.3z"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  className: "st41",
  d: "M168.4,182.3c-3.4-3.3-7-6.4-10.8-9.3l-7.9,10.3c3.4,2.6,6.6,5.4,9.7,8.3L168.4,182.3z"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  className: "st41",
  d: "M145.9,164.9c-1.9-1.2-3.9-2.3-5.9-3.4l-6.3,11.4c1.8,1,3.6,2.1,5.4,3.1L145.9,164.9z"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  className: "st42",
  d: "M471.4,65.9v3.3c0,14.9-6.2,29.1-17.1,39.2l-86.9,80.2l-86.9-80.2c-10.9-10.1-17.1-24.3-17.1-39.2v-3.3 c0-14.8,5.9-28.1,15.6-37.8s23-15.6,37.8-15.6c16.8,0,32.6,7.9,42.6,21.4l8,10.6l8-10.6c5-6.7,11.5-12.1,18.8-15.8 c7.3-3.6,15.4-5.6,23.8-5.6C447.6,12.6,471.4,36.4,471.4,65.9z"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M303.4,69.2h-16c0,8.2,3.4,16,9.4,21.6l65.1,60.1l10.9-11.8L307.7,79C305,76.5,303.4,72.9,303.4,69.2z"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M418.1,4.6c-19.2,0-37.5,9.2-49.1,24.5l-1.6,2.1l-1.6-2.1c-11.5-15.4-29.9-24.5-49.1-24.5c-33.8,0-61.3,27.5-61.3,61.3v3.3 c0,17.1,7.2,33.5,19.7,45.1l92.3,85.2l92.3-85.2c12.5-11.6,19.7-28,19.7-45.1v-3.3C479.4,32.1,451.9,4.6,418.1,4.6z M463.4,69.2 c0,12.6-5.3,24.8-14.6,33.3l-81.4,75.2L286,102.5c-9.3-8.6-14.6-20.7-14.6-33.3v-3.3c0-25,20.3-45.3,45.3-45.3 c14.2,0,27.8,6.8,36.3,18.1l14.4,19.2l14.4-19.2c8.5-11.4,22.1-18.1,36.3-18.1c25,0,45.3,20.3,45.3,45.3L463.4,69.2L463.4,69.2z"
});

var SvgFreeofcharge = function SvgFreeofcharge(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFreeofcharge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/freeofcharge.e3ffcff5.svg";
export { ForwardRef as ReactComponent };